type IconProps = React.HTMLAttributes<SVGElement>;

export const BoxesLine = (props: IconProps) => {
	return (
		<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M13 3L17.2353 5.45455V10.3636L13 12.8182L8.76471 10.3636V5.45455L13 3ZM13 4.25165L15.6202 5.77018L13 7.29926L10.3798 5.77018L13 4.25165ZM9.82353 6.69932L12.4706 8.24406V11.2597L9.82353 9.72562V6.69932ZM13.5294 11.2597V8.24406L16.1765 6.69932V9.72562L13.5294 11.2597ZM12.4706 13.6364L8.23529 11.1818L4 13.6364V18.5455L8.23529 21L12.4706 18.5455V13.6364ZM10.8555 13.952L8.23529 12.4335L5.61508 13.952L8.23529 15.4811L10.8555 13.952ZM7.70588 16.4259L5.05882 14.8811V17.9074L7.70588 19.4415V16.4259ZM8.76471 16.4259V19.4415L11.4118 17.9074V14.8811L8.76471 16.4259ZM22 13.6364L17.7647 11.1818L13.5294 13.6364V18.5455L17.7647 21L22 18.5455V13.6364ZM20.3849 13.952L17.7647 12.4335L15.1445 13.952L17.7647 15.4811L20.3849 13.952ZM17.2353 16.4259L14.5882 14.8811V17.9074L17.2353 19.4415V16.4259ZM18.2941 16.4259V19.4415L20.9412 17.9074V14.8811L18.2941 16.4259Z"
				fill="currentColor"
			/>
		</svg>
	);
};
